import React from 'react';
import {
  Standard,
  Special,
  Symposium,
  DocumentarySummary,
  LongRead,
  BooksInProgressSection,
} from '../components/issues/section-type';

export const getPublishedIssues = (issueIds, allIssues) => {
  const issuesWithOrder = issueIds.map((issue, idx) => ({
    ...issue,
    order: idx + 1,
  }));

  return allIssues
    .filter((issue) => issueIds.find((item) => Number(item.id) === issue.databaseId))
    .filter((issue) => {
      if (issue.tghpwipIssuesTaxonomyCategory && issue.tghpwipIssuesTaxonomyCategory === 'books in progress section') {
        return !!issue.tghpwipIssuesTaxonomyBipsectionSection;
      } else {
        return issue.posts.nodes.length > 0;
      }
    })
    .map((issue) => {
      const item = issuesWithOrder.find((item) => Number(item.id) === issue.databaseId);
      return {
        ...issue,
        order: item.order,
        posts: {
          nodes: issue.posts.nodes.filter((post) => {
            return post.tghpwipPostIsPreview !== '1';
          }),
        }
      };
    })
    .sort((issueA, issueB) => issueB.order - issueA.order);
};

export const removeBipSectionIssue = (issues) => {
  return issues.filter(issue => {
    return issue.tghpwipIssuesTaxonomyCategory && issue.tghpwipIssuesTaxonomyCategory !== 'books in progress section';
  });
}

export const getCategorisedIssues = (issueArray) => {
  const issueComponents = {
    standard: Standard,
    special: Special,
    symposium: Symposium,
    film: DocumentarySummary,
    'long read': LongRead,
    'books in progress section': BooksInProgressSection,
  };

  return issueArray.map((issue, index) => {
    const issueProps = {
      issue,
      key: issue.databaseId,
      lazyLoad: index > 0,
    };

    if (
      issue.tghpwipIssuesTaxonomyCategory &&
      issueComponents[issue.tghpwipIssuesTaxonomyCategory]
    ) {
      const IssueComponent = issueComponents[issue.tghpwipIssuesTaxonomyCategory];
      return <IssueComponent {...issueProps} />;
    }

    return null;
  });
};
